import { client } from "../client";
import type { Paginated, PaginatedFilter } from "../types/axios.types";
import type { SavedFile } from "../types/files.types";
import type { Ticket, TicketLog } from "../types/ticket.types";

export const fetchTickets = async (
	page?: number,
	size?: number,
	search?: string,
	filters?: PaginatedFilter,
	sortBy?: string[],
) => {
	const params = new URLSearchParams();
	// Pagination
	params.append("page", page ? page.toString() : "1");
	params.append("size", size ? size.toString() : "25");
	// Search
	if (search) {
		params.append("search", search);
	}
	// Sort
	if (sortBy) {
		sortBy.forEach((key) => params.append("sort", key));
	}
	// Filters
	if (filters) {
		Object.keys(filters).forEach((key: string) => {
			// Blacklist some keys
			if (
				["page", "size", "search", "sort"].includes(key) ||
				filters[key] === ""
			) {
				return;
			}
			params.append(
				key,
				Array.isArray(filters[key]) ? filters[key].join(",") : filters[key],
			);
		});
	}
	// Query
	const response = await client.get<Paginated<Ticket[]>>(`tickets/`, {
		params,
	});
	return response.data;
};

export const fetchTicket = async (id?: number | string) => {
	if (id === undefined) {
		return null;
	}
	const response = await client.get<Ticket>(`tickets/${id}`);
	return response.data;
};

export const fetchTicketDocuments = async (id?: number | string) => {
	if (id === undefined) {
		return null;
	}
	const response = await client.get<SavedFile[]>(`tickets/documents/${id}`);
	return response.data;
};

export const fetchTicketLogs = async (id?: number | string) => {
	if (id === undefined) {
		return null;
	}
	const response = await client.get<TicketLog[]>(`tickets/logs/${id}`);
	return response.data;
};

export type TicketMessageResponse = {
	id: number;
	content: string;
	meta: object | null;
	createdAt: string;
	updatedAt: string;
	authorId: number;
	author: {
		id: number;
		firstName: string | null;
		lastName: string | null;
		email: string;
		isSuperAdmin: boolean;
	};
};

export const fetchTicketMessages = async (id?: number | string) => {
	if (id === undefined) {
		return null;
	}
	const response = await client.get<TicketMessageResponse[]>(
		`tickets/${id}/messages`,
	);
	return response.data;
};
